/**
 * 공개 API 클라이언트
 * 토큰 없이 접근 가능한 API 호출 (회원가입, FAQ, 로그인 등)
 * 인증이 필요 없는 공개 엔드포인트용
 */

import axios, { AxiosError } from "axios";
import { config } from "../config/env";

const publicClient = axios.create({
  baseURL: config.apiHost,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * 에러 처리
 * 401, 403 등의 에러도 그대로 던짐 (상위에서 처리)
 */
publicClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("Public API Error:", error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export { publicClient };
